import * as Yup from "yup";

export const validation = (t) =>
    Yup.object({
        email: Yup.string()
            .email(t("registration.invalidEmail"))
            .max(255)
            .required(t("login.required")),
        password: Yup.string()
            .min(8, t("registration.passwordLength"))
            .max(255)
            .required(t("login.required")),
    });
